let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aR0eP")).then(() => parcelRequire('4DSvP'));